export enum ResourceType {
    FOOD = 'FOOD',
    WOOD = 'WOOD',
    GOLD = 'GOLD',
    STONE = 'STONE'
}